import styled from "styled-components";

export const FirstScreenPairingModalContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
`;
